import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class RockBottomGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_ON_POLAROID = "multiplier";

    public static MAIN_GAME_BACKGROUND: string = "mainBackground";
    public static BONUS_GAME_BACKGROUND: string = "freespinBackground";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset(RockBottomGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(RockBottomGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(RockBottomGameAssets.BITMAP_ON_POLAROID, "fonts/bitmapfonts/multiplier.fnt")
                ]
            },
            {
                name: "noTinyPng",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("noTinyPng0", "sheets/noTinyPng/noTinyPng0.json"),
                    new TextureAsset("noTinyPng1", "sheets/noTinyPng/noTinyPng1.json")
                ],
                animations: {
                    "reelBackground": "reelFrame",
                    "reelBackgroundAnti": "reelFrameAnti",
                    "fsIntroImg": "FS_intro/introFS",
                    "sfsIntroImg": "FS_intro/introSFS",
                    "fsOutroImg": "FS_outro/OutroFS",
                    "sfsOutroImg": "FS_outro/OutroSFS",
                    "rightFlush": "xBet/toilet2",
                    "introSplash": "intro_splash/Intro-Splash"
                }
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("FS_BG_Spine", "spine/FS_BG.json"),
                    new SpineAsset("MG_BG_Spine", "spine/MG_BG.json"),
                    new SpineAsset("MG_BG_Light_Flicker_Spine", "spine/MG_BG_Light_Flicker.json"),
                    new SpineAsset("L1", "spine/L1.json"),
                    new SpineAsset("L2", "spine/L2.json"),
                    new SpineAsset("L3", "spine/L3.json"),
                    new SpineAsset("L4", "spine/L4.json"),
                    new SpineAsset("L5", "spine/L5.json"),
                    new SpineAsset("M1", "spine/M1.json"),
                    new SpineAsset("M2", "spine/M2.json"),
                    new SpineAsset("M3", "spine/M3.json"),
                    new SpineAsset("M4", "spine/M4.json"),
                    new SpineAsset("M5", "spine/M5.json"),
                    new SpineAsset("S", "spine/S.json"),
                    new SpineAsset("X", "spine/X.json"),
                    new SpineAsset("XS", "spine/Xs.json"),
                    new SpineAsset("M_Symbol_Reveal", "spine/M_Symbol_Reveal.json"),
                    new SpineAsset("Wine_Bottle", "spine/Bottel.json"),
                    new SpineAsset("Symbol_Highlight", "spine/Symbol_Highlight.json"),
                    new SpineAsset("softCap", "spine/softCap.json"),
                    new SpineAsset("SoftWin_level1", "spine/Softwin_level1.json"),
                    new SpineAsset("SoftWin_level2", "spine/Softwin_level2.json"),
                    new SpineAsset("SW_Level_3_M2", "spine/SW_Level_3_M2.json"),
                    new SpineAsset("SW_Level_3_M3", "spine/SW_Level_3_M3.json"),
                    new SpineAsset("SW_Level_3_M4", "spine/SW_Level_3_M4.json"),
                    new SpineAsset("SW_Level_3_M5", "spine/SW_Level_3_M5.json"),
                    new SpineAsset("Level_up", "spine/Level_up.json"),
                    new SpineAsset("levelUpM2", "spine/levelUpM2.json"),
                    new SpineAsset("levelUpM3", "spine/levelUpM3.json"),
                    new SpineAsset("levelUpM4", "spine/levelUpM4.json"),
                    new SpineAsset("levelUpM5", "spine/levelUpM5.json"),
                    new SpineAsset("levelUpM1", "spine/levelUpM1.json"),
                    new SpineAsset("xSplit", "spine/Xsplit.json"),
                    new SpineAsset("xBet", "spine/Xbet.json"),
                    new SpineAsset("W_Reveal", "spine/W_Reveal.json"),
                    new SpineAsset("Eyeblink", "spine/Eyeblink.json"),
                    new SpineAsset("S_Anti", "spine/S_Anti.json"),
                    new SpineAsset("softWinCapChoose", "spine/PickNclick_V01.json"),
                    new SpineAsset("FS_intro", "spine/FS_intro.json"),
                    new SpineAsset("SFS_intro", "spine/SFS_intro.json"),
                    new SpineAsset("SW_Level_05", "spine/SW_Level_05.json"),
                    new SpineAsset("bigwin_L1", "spine/bigwin_L1.json"),
                    new SpineAsset("bigwin_L2", "spine/bigwin_L2.json"),
                    new SpineAsset("bigwin_L3", "spine/bigwin_L3.json"),
                    new SpineAsset("bigwin_L4", "spine/bigwin_L4.json"),
                    new SpineAsset("bigwin_L5", "spine/bigwin_L5.json"),
                    new SpineAsset("Xsplit_Symbol_Higlight", "spine/Xsplit_Symbol_Higlight.json"),
                    new SpineAsset("SW_Level_X10", "spine/SW_Level_X10.json"),
                    new SpineAsset("Paper_Fly", "spine/Paper_Fly.json")
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json")
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json"),
                    new TextureAsset("main8", "sheets/main/main8.json"),
                    new TextureAsset("main9", "sheets/main/main9.json"),
                    new TextureAsset("main10", "sheets/main/main10.json"),
                    new TextureAsset("main11", "sheets/main/main11.json")
                ],
                animations: {
                    "logo": "Logo/Logo_Landscape",
                    "normalBottle": "Indicator/Indicator",
                    "crackedBottle": "Indicator/cracked_bottle",
                    "plusOneSpin": "PlusOneSpinImage/PlusOneFreeSpin",
                    "plusTwoSpin": "PlusOneSpinImage/Plus2FreeSpin",
                    "scatterAnticipation": "S_Anti/S_Anti_",
                    "fsOutroString": "Fs_Outro/OutroFS_string"
                }
            },
            {
                name: "mainJpeg",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json")
                    
                    
                ],
                animations: {
                    "reelPanel": "Reel_Panel/reelPanel",
                    "endLevel_X10": "Bg_Anim/endLevel_X10",
                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json"),
                ],
                animations: {
                    "M1_Clean": "M1/M1_Clean",
                    "M2_Clean": "M2/M2_Clean",
                    "M3_Clean": "M3/M3_Clean",
                    "M4_Clean": "M4/M4_Clean",
                    "M5_Clean": "M5/M5_Clean",
                    "M1_Drink": "M1/M1_Drink",
                    "M2_Drink": "M2/M2_Drink",
                    "M3_Drink": "M3/M3_Drink",
                    "M4_Drink": "M4/M4_Drink",
                    "M5_Drink": "M5/M5_Drink",
                    "M1_WornOut": "M1/M1_WornOut",
                    "M2_WornOut": "M2/M2_WornOut",
                    "M3_WornOut": "M3/M3_WornOut",
                    "M4_WornOut": "M4/M4_WornOut",
                    "M5_WornOut": "M5/M5_WornOut"
                }
            },

        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }
}